import React, { ReactNode, useState } from 'react';
import styled from 'styled-components';

type Props = {
    children?: ReactNode,
}

const scrollTop = (): void => {
    typeof window !== 'undefined' &&
    window.scroll({
        top: 0,
        behavior: 'smooth',
    });
};

const ScrollToTop = (props: Props) => {
    const { children } = props;

    const [pageYOffset, setPageYOffset] = useState(0);
    window.addEventListener('scroll', () => {
        setPageYOffset(window.pageYOffset);
    });

    return (
        <ScrollToTopWithStyled className={`${!pageYOffset && 'd-none'}`} onClick={ scrollTop } { ...props }>
            { children || 'TOP' }
        </ScrollToTopWithStyled>
    )
}

const ScrollToTopWithStyled = styled.div`
    position: fixed;
    bottom: 40px;
    right: 24px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 1px solid #5a5a5a;
    color: #5a5a5a;
    background: #fff;
    text-align: center;
    line-height: 50px;
    transition: all 0.4s ease;

    &:hover {
        color: #fff;
        background: #5a5a5a;
        transform: scale(1.15);
        cursor: pointer;
    }

    @media print {
        display: none;
    }
`;

export default ScrollToTop;